<div
  class="upload-pill"
  *ngIf="visible"
  [class.has-failures]="failedCount > 0"
  (click)="toggleDetail()"
>
  <ion-progress-bar
    *ngIf="activeCount > 0"
    [value]="progress"
  ></ion-progress-bar>
  <span class="label">{{ label }}</span>
</div>
